import React from 'react';
import {FieldArray, useFormikContext} from 'formik';
import classNames from 'classnames';

import FormikTextInput from '../inputs/formik-text-input';
import Fieldset from 'shared/components/fieldset';
import RemoveButton from '../RemoveButton';
import FormButton from 'src/components/button';
import styles from './styles.module.scss';

export interface Props {
  placeholderText?: string;
  addButtonText?: string;
  showRemoveButton?: boolean;
  title: string;
}

const StudentReferrals = ({
  placeholderText = 'Enter an email address or phone number',
  addButtonText = 'Invite Another Friend',
  showRemoveButton = true,
  title,
}: Props) => {
  const formik = useFormikContext<{referrals: string[]}>();

  return (
    <div data-testid="student-referrals">
      <Fieldset className="mt-0">
        <Fieldset.Legend>{title}</Fieldset.Legend>

        <FieldArray
          name="referrals"
          render={({push, remove}) => (
            <>
              {formik.values.referrals.map((_, i) => (
                <div
                  key={`referral-${i}`}
                  className={classNames(styles.item, {[styles.grid]: showRemoveButton})}
                  data-testid="student-referral-item"
                >
                  <FormikTextInput name={`referrals.${i}`} placeholder={placeholderText} />
                  {showRemoveButton && i > 0 && <RemoveButton onRemove={() => remove(i)} />}
                </div>
              ))}

              <div className={styles.button}>
                <FormButton
                  color="primary"
                  outline
                  disabled={false}
                  margin={false}
                  onClick={() => push('')}
                  type="button"
                  buttonName="portfolio student-referrals invite-another-friend"
                >
                  {addButtonText}
                </FormButton>
              </div>
            </>
          )}
        />
      </Fieldset>
    </div>
  );
};

export default StudentReferrals;
